"use client";

import Script from "next/script";
import { useConsent } from "./consent";

/**
 * Google Analytics 4, gated on consent.
 *
 * Nothing is requested from googletagmanager.com until consent is granted —
 * this does not use Consent Mode's denied-state pings, so a visitor who
 * declines generates no request to Google at all.
 *
 * Loaded through next/script with `afterInteractive` rather than raw <script>
 * tags: the App Router streams its HTML, so a hand-written inline script is
 * not guaranteed to run in the order it appears, and this keeps gtag off the
 * critical path.
 *
 * The measurement ID comes from NEXT_PUBLIC_GA_ID and is deliberately absent
 * from .env.local, so local development sends no events either way.
 */
export function Analytics() {
  const { consent } = useConsent();
  const id = process.env.NEXT_PUBLIC_GA_ID;

  if (!id || consent !== "granted") return null;

  return (
    <>
      <Script src={`https://www.googletagmanager.com/gtag/js?id=${id}`} strategy="afterInteractive" />
      <Script id="ga4-init" strategy="afterInteractive">
        {`window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());
gtag('config', '${id}');`}
      </Script>
    </>
  );
}
